import { render, staticRenderFns } from "./reportCustomerSale.vue?vue&type=template&id=54b67c3c&scoped=true"
import script from "./reportCustomerSale.vue?vue&type=script&lang=js"
export * from "./reportCustomerSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b67c3c",
  null
  
)

export default component.exports